import { FC, ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import clsx from 'clsx';
import { Icon } from '@scale/scaleui';

export type OutlinePanelProps = {
  title?: string;
  showOutline: boolean;
  onClose: () => void;
  children: ReactNode;
  displayHovered?: boolean;
  className?: string;
  theme?: string;
};

export const OutlinePanel: FC<OutlinePanelProps> = ({
  title,
  showOutline,
  onClose,
  children,
  displayHovered,
  className,
  theme,
}) => {
  return (
    <AnimatePresence>
      {showOutline && (
        <motion.div
          className={clsx([
            displayHovered
              ? 'absolute top-16 z-10 h-[calc(100%_-_4rem)] border-r border-r-neutral-200'
              : 'h-full border border-neutral-200',
            'w-[500px] p-4 bg-neutral-0 overflow-y-scroll',
            theme,
            className,
          ])}
          style={{ paddingBottom: '6rem' }}
          initial={{ x: -350 }}
          animate={{ x: 0 }}
          exit={{ x: -650 }}
          transition={{
            ease: 'easeOut',
            duration: 0.2,
          }}
        >
          <div className="relative space-y-4">
            <div className="flex justify-between items-center">
              <span className="text-lg text-neutral-700">{title ?? 'Outline'}</span>
              <Icon icon="close" size="sm" onClick={onClose} />
            </div>
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
